import { HttpClient } from '@angular/common/http';
import { Injectable, effect, inject } from '@angular/core';
import { ENVIRONMENT } from '@front/shared/util-environment';
import { MeiliSearch } from 'meilisearch';
import { map, Observable } from 'rxjs';
import { AuthStore } from '../stores/auth.store';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  readonly enviroment = inject(ENVIRONMENT);
  private http = inject(HttpClient);
  private authStore = inject(AuthStore);
  readonly meiliApiUrl = `${this.enviroment.cmsApiUrl}/search-key`;
  private client?: MeiliSearch;
  private index?: ReturnType<MeiliSearch['index']>;
  private isInitializing = false;

  constructor() {
    effect(() => {
      const roleName = this.authStore.user()?.role?.name;
      const canUseSearch = Boolean(roleName && roleName !== 'Client');

      if (!canUseSearch || this.index || this.isInitializing) {
        return;
      }

      this.isInitializing = true;
      this.getPublicKey().subscribe({
        next: (key) => {
          this.client = new MeiliSearch({
            host: this.enviroment.meilisearchUrl || 'http://localhost:7700',
            apiKey: key,
          });
          this.index = this.client.index('company');
        },
        error: () => {
          this.isInitializing = false;
        },
        complete: () => {
          this.isInitializing = false;
        },
      });
    });
  }

  async search(query: string) {
    if (this.authStore.user()?.role?.name === 'Client') {
      return { hits: [] };
    }

    if (!this.index) {
      throw new Error('MeiliSearch client not initialized');
    }
    return await this.index.search(query, {
      limit: 10,
    });
  }

  getPublicKey(): Observable<string> {
    return this.http
      .get<string>(`${this.enviroment.cmsApiUrl}/search-key`)
      .pipe(map((res) => res));
  }
}
